<template>
	<div class="content">
		<el-form :model="propsParams" ref="propsParams" label-width="100px" class="demo-ruleForm" :rules="rules">
			<el-form-item label="问题：" prop="question" label-width="130px">
				<el-input v-model="propsParams.question" style="width:500px" placeholder="问题"></el-input>
      </el-form-item>
			<el-form-item label="问题类型：" prop="type" label-width="130px">
          <el-select v-model="propsParams.type" filterable placeholder="请选择问题类型" @change="operation">
            <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
      </el-form-item>
			<el-form-item label="答案：" prop="answer" label-width="130px">
				<el-input type="textarea" :rows="5" v-model="propsParams.answer" style="width:500px" placeholder="请输入问题的答案"></el-input>
      </el-form-item>
			<el-button type="primary" class="buttonclass" @click="handleSubmit()" v-hasPermi="['help:center:helpAdd']">提交</el-button>
		</el-form>
	</div>
</template>
<script>
import { helpAdd } from "@/api/api.js";
export default {
	name:'addHelp',
	data(){
		return {
			// 表单验证
			rules:{
        question: [
          { required: true, message: "请输入问题", trigger: "blur" }
				],
        type: [
          { required: true, message: "请选择问题类型", trigger: "blur" }
				],
        answer: [
          { required: true, message: "请输入答案", trigger: "blur" }
				],
			},
			propsParams:{},
      typeList:[
        {value:'0',label: "常见问题"},
        {value:'1',label: "充值问题"},
        {value:'2',label: "网络问题"},
        {value:'3',label: "设备问题"},
        {value:'4',label: "其他问题"},
      ],
		}
	},
	computed:{},
	methods:{
		// 提交
		handleSubmit(){
			this.$refs.propsParams.validate(valid => {
				let params = {
					...this.propsParams,
				};
        helpAdd(params).then(res=>{
					if(res.data.code == 200){
						this.$notify({
							title: "成功",
							message: "新增短信模版成功",
							type: "success",
							duration: 1500
						});
						this.$router.push('/helpCenter/helpList')
					}else{
						this.$message.error(res.data.message);
					}
				})
			})
		},
    operation(){}
	},
	created(){

	},
	mounted(){
		
	}
}
</script>
<style scoped>
	.quan_class{
		width: 300px;
		min-height: 95px;
    overflow-y: auto;
		border: 1px solid #d1d9e2;
		border-radius: 4px;
		background: #fff;
		text-indent: 2px;
	}
	.checkboxgroupclass{
		width: 290px;
	}
	.checkboxclass{
		width: 37%;
		text-align: left;
	}
	.buttonclass{
		margin-left: 133px;
		margin-top: 20px;
	}
</style>
